// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zn8CU","col":"styles_col__3bS7f","actions":"styles_actions__RRJU1","conflict":"styles_conflict__1Mg28"};